import { render, staticRenderFns } from "./SchoolAddressComponent.vue?vue&type=template&id=5790a3e6"
import script from "./SchoolAddressComponent.vue?vue&type=script&lang=js"
export * from "./SchoolAddressComponent.vue?vue&type=script&lang=js"
import style0 from "./SchoolAddressComponent.vue?vue&type=style&index=0&id=5790a3e6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports